// styles
require('./personeticsSubscriptionModal.scss');
require('./personeticsSubscriptionModal.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');
// @constants
const modalHeaderImg = require('assets/images/referrals-preview-logo.png');
const {
    PERSONETICS_SUBSCRIPTION_TERMS_AND_CONDS_LINK
} = require('constants/index');
const {
    PERSONETICS_EVENT_CATEGORY,POSITION_GLOBAL_EVENT_CATEGORY
} = require('constants/tagging');
//@utils
const { FormattedText } = require('core/i18n').i18n;
const { recordLinkV2 } = require('utilities/tagging');

class PersoneticsSubscriptionModal extends React.Component {

    constructor(props) {
        super(props);

        this.handleOnTermsChange = this.handleOnTermsChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this)
    }

    componentDidUpdate(prevProps){
    const {
            showModal
        } = this.props;
    const analyticsData = {
        categoriaEvento:PERSONETICS_EVENT_CATEGORY,
        accionEvento: "terminos y condiciones",
        etiquetaEvento: "open",
        zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
    }
   if(prevProps.showModal !==showModal && showModal ){
     recordLinkV2(analyticsData)}
    }
    

    handleOnTermsChange(event) {
        const analyticsData = {
        categoriaEvento:PERSONETICS_EVENT_CATEGORY,
        accionEvento: "terminos y condiciones",
        etiquetaEvento: event.target.checked ? "checked":"unchecked",
        zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        this.props.checkboxClick(event.target.checked);
    }

    handleClose = () => {
        const { handleClose } = this.props;
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "terminos y condiciones",
            etiquetaEvento: "close",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        handleClose();
    }

    handleSubmit() {
        const { handleSubmit } = this.props;
        const analyticsData = {
        categoriaEvento:PERSONETICS_EVENT_CATEGORY,
        accionEvento: "terminos y condiciones",
        etiquetaEvento: "confirmar",
        zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        handleSubmit();
    }
    handleAnalytics() {
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "terminos y condiciones",
            etiquetaEvento: "link",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
            }
            recordLinkV2(analyticsData);
    }
    buildModal() {
        const {
            showModal,
            isUpdatingPersoneticsSubscription,
            checkboxChecked
        } = this.props;

        const content = (
            <div className="personetics-subscription-modal__content">
                <div className="personetics-subscription-modal__content__terms">
                    <FormattedText value="personeticsSubscriptionModal-termsContent"/>
                </div>
            </div>
        );

        const checkBoxLabel = (
        <span>
            <FormattedText value="personeticsSubscriptionModal-termsCheckboxOne"/>&nbsp;
            <OKLink class="personetics-subscription-modal__checkbox-label-link" target="_blank"  onClick={this.handleAnalytics} to={PERSONETICS_SUBSCRIPTION_TERMS_AND_CONDS_LINK}>
                <FormattedText value="personeticsSubscriptionModal-termsCheckboxTwo"/>
            </OKLink>&nbsp;
            <FormattedText value="personeticsSubscriptionModal-termsCheckboxThree"/>
        </span>);

        const contentFooter = (
            <div className="personetics-subscription-modal__checkbox">
                <OKCheckbox
                    idName="personetics-subscription-terms"
                    onChange={this.handleOnTermsChange}
                    label={checkBoxLabel}
                    value={checkboxChecked}
                />
            </div>
        );

        return (
            <OKModal
                content={content}
                contentFooter={contentFooter}
                contentOverflow="auto"
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeaderImg}
                headerImageWidth="250px"
                headerType="image"
                isOpen={showModal}
                onCloseCallback={this.handleClose}
                onPrimaryButtonClick={this.handleSubmit}
                overlayClassName="personetics-subscription-modal"
                primaryButtonDisabled={!checkboxChecked}
                primaryButtonLoading={isUpdatingPersoneticsSubscription}
                primaryButtonText="common-continue"
                size="large"
                title="personeticsSubscriptionModal-modalTitle"
            />
        )
    }

    render() {
        return (
            <div>
                {this.buildModal()}
            </div>
        )
    }
}

PersoneticsSubscriptionModal.defaultProps = {
    checkboxChecked: false,
    isUpdatingPersoneticsSubscription: false
}

PersoneticsSubscriptionModal.propTypes = {
    checkboxChecked: PropTypes.bool.isRequired,
    checkboxClick: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleTermsAndConditions: PropTypes.func.isRequired,
    handleToggleModal: PropTypes.func.isRequired,
    isUpdatingPersoneticsSubscription: PropTypes.bool.isRequired,
    showModal: PropTypes.bool.isRequired,
};

module.exports = PersoneticsSubscriptionModal;
